// import  { useState, useEffect } from "react";
// import { Button, Grid, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, FormControl, InputLabel, Select, CircularProgress,  Typography } from "@material-ui/core";

// import axios from "axios";
// import { BACKEND_BASE_URL } from "../config";

// const EditMappingForm = ({ open, onClose, onMappingUpdated, mappingData }) => {
    
//     const [stateOptions, setStateOptions] = useState([]);
//     const [countyOptions, setCountyOptions] = useState([]);
//     const [municipalityOptions, setMunicipalityOptions] = useState([]);
//     const [loadingStates, setLoadingStates] = useState(false);
//     const [loadingCounties, setLoadingCounties] = useState(false);
//     const [loadingMunicipalities, setLoadingMunicipalities] = useState(false);
//     const [loading, setLoading] = useState({ states: false, counties: false, municipalities: false, associatedCounties: false })
//     const [channelOptions, setChannelOptions] = useState([]);
//     const [associatedCountyOptions, setAssociatedCountyOptions] = useState([]);
//     const [associatedMunicipalityOptions, setAssociatedMunicipalityOptions] = useState([]);

//     const [formData, setFormData] = useState({
//         state: "",
//         county: "",
//         municipality_name: "",
//         municipalities: [],
//     });

//     const [newMunicipality, setNewMunicipality] = useState({
//         state: "",
//         county: "",
//         municipality_name: "",
//         channel_type: "Board of Education",
//         channel_urls: [],
//     });

//     useEffect(() => {
//         if (open && mappingData) {
//             setFormData({
//                 state: mappingData.big_town.state,
//                 county: mappingData.big_town.county,
//                 municipality_name: mappingData.big_town.municipality_name,
//                 municipalities: mappingData.small_town[0] ? [mappingData.small_town[0]] : [],
//             });
//             setNewMunicipality({
//                 state: mappingData.small_town[0].state,
//                 county: mappingData.small_town[0].county,
//                 municipality_name: mappingData.small_town[0].municipality_name,
//                 channel_type: "Board of Education",
//                 channel_urls: mappingData.small_town[0].channel_urls,
//             })
//         }
//     }, [open, mappingData]);

//     useEffect(() => {
//         if (open) fetchStates();
//     }, [open]);

//     useEffect(() => {
//         if (formData.state) fetchCounties();
//         else setCountyOptions([]);
//     }, [formData.state]);

//     useEffect(() => {
//         if (formData.state && formData.county) fetchMunicipalities();
//         else setMunicipalityOptions([]);
//     }, [formData.state, formData.county]);

//     useEffect(() => {
//         if (formData.state && formData.county && formData.municipality_name) fetchChannels();
//         else setChannelOptions([]);
//     }, [formData.state, formData.county, formData.municipality_name]);

//     useEffect(() => {
//         if (newMunicipality.state) fetchAssociatedCounties();
//         else setAssociatedCountyOptions([]);
//     }, [newMunicipality.state]);

//     useEffect(() => {
//         if (newMunicipality.state && newMunicipality.county) fetchAssociatedMunicipalities();
//         else setAssociatedMunicipalityOptions([]);
//     }, [newMunicipality.state, newMunicipality.county]);

//     const fetchAssociatedCounties = async () => {
//         setLoading((prev) => ({ ...prev, associatedCounties: true }));
//         try {
//             const { data } = await axios.get(`${BACKEND_BASE_URL}/api/counties/`, { params: { state: newMunicipality.state } });
//             setAssociatedCountyOptions(data?.counties || []);
//         } catch (error) {
//             console.error("Error fetching counties:", error);
//         }
//         setLoading((prev) => ({ ...prev, associatedCounties: false }));
//     };

//     const fetchAssociatedMunicipalities = async () => {
//         setLoading((prev) => ({ ...prev, associatedMunicipalities: true }));
//         try {
//             const { data } = await axios.get(`${BACKEND_BASE_URL}/api/municipalities/filter/`, { params: { state: newMunicipality.state, county: newMunicipality.county } });
//             setAssociatedMunicipalityOptions(data?.municipalities || []);
//         } catch (error) {
//             console.error("Error fetching municipalities:", error);
//         }
//         setLoading((prev) => ({ ...prev, associatedMunicipalities: false }));
//     };

//     const fetchStates = async () => {
//         setLoadingStates(true);
//         try {
//             const { data } = await axios.get(`${BACKEND_BASE_URL}/api/states/`);
//             setStateOptions(data?.states || []);
//         } catch (error) {
//             console.error("Error fetching states:", error);
//         }
//         setLoadingStates(false);
//     };

//     const fetchCounties = async () => {
//         setLoadingCounties(true);
//         try {
//             const { data } = await axios.get(`${BACKEND_BASE_URL}/api/counties/`, { params: { state: formData.state } });
//             setCountyOptions(data?.counties || []);
//         } catch (error) {
//             console.error("Error fetching counties:", error);
//         }
//         setLoadingCounties(false);
//     };

//     const fetchMunicipalities = async () => {
//         setLoadingMunicipalities(true);
//         try {
//             const { data } = await axios.get(`${BACKEND_BASE_URL}/api/municipalities/filter/`, {
//                 params: { state: formData.state, county: formData.county },
//             });
//             setMunicipalityOptions(data?.municipalities || []);
//         } catch (error) {
//             console.error("Error fetching municipalities:", error);
//         }
//         setLoadingMunicipalities(false);
//     };

//     const fetchChannels = async () => {
//         setLoading((prev) => ({ ...prev, channels: true }));
//         try {
//             const { data } = await axios.get(`${BACKEND_BASE_URL}/api/municipality/channel-urls/`, {
//                 params: { state: formData.state, county: formData.county, municipality: formData.municipality_name },
//             });
//             setChannelOptions(data?.channel_urls || []);
//         } catch (error) {
//             console.error("Error fetching channels:", error);
//         }
//         setLoading((prev) => ({ ...prev, channels: false }));
//     };

//     const handleChange = (event) => {
//         setFormData({ ...formData, [event.target.name]: event.target.value });
//         setNewMunicipality((prev) => ({
//             ...prev,
//             channel_urls: [], // Reset channel URLs
//         }));
//     };

//     const handleMunicipalityChange = (event) => {
//         setNewMunicipality(prev => ({
//             ...prev,
//             [event.target.name]: event.target.value
//         }));
//     };


//     const handleChannelSelect = (event) => {
//         setNewMunicipality({ ...newMunicipality, channel_urls: event.target.value });
//     };

//     const handleSave = async () => {
//         setLoading(true);
//         try {
//             const updatedMunicipalities = [...formData.municipalities, newMunicipality];

//             await axios.patch(`${BACKEND_BASE_URL}/api/mapping-towns/${mappingData.id}/`, {
//                 state: formData.state,
//                 county: formData.county,
//                 big_town: formData.municipality_name,
//                 small_town: updatedMunicipalities,
//             });
//             onClose();
//             onMappingUpdated();
//         } catch (error) {
//             console.error("Error updating mapping:", error);
//         }
//         setLoading(false);
//     };

//     return (
//         <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
//             <DialogTitle>Edit Mapping</DialogTitle>
//             <DialogContent>
//                 {/* State Dropdown */}
//                 <FormControl fullWidth margin="dense">
//                     <InputLabel>State</InputLabel>
//                     <Select name="state" value={formData.state} onChange={handleChange} fullWidth>
//                         {stateOptions.map((state) => <MenuItem key={state} value={state}>{state}</MenuItem>)}
//                     </Select>
//                 </FormControl>

//                 {/* County Dropdown */}
//                 <FormControl fullWidth margin="dense" disabled={!formData.state}>
//                     <InputLabel>County</InputLabel>
//                     <Select name="county" value={formData.county} onChange={handleChange} fullWidth>
//                         {countyOptions.map((county) => <MenuItem key={county} value={county}>{county}</MenuItem>)}
//                     </Select>
//                 </FormControl>

//                 {/* Town Dropdown */}
//                 <FormControl fullWidth margin="dense" disabled={!formData.state || !formData.county}>
//                     <InputLabel>Town</InputLabel>
//                     <Select name="municipality_name" value={formData.municipality_name} onChange={handleChange} fullWidth>
//                         {municipalityOptions.map((municipality) => <MenuItem key={municipality} value={municipality}>{municipality}</MenuItem>)}
//                     </Select>
//                 </FormControl>

//                 {/* Associated Towns Section */}
//                 <Typography variant="h6" style={{ marginTop: 10 }}>Associated Towns</Typography>
//                 <Grid container spacing={1}>
//                     <Grid item xs={2}>
//                         {/* <TextField fullWidth label="State" name="state" value={newMunicipality.state} onChange={handleMunicipalityChange} margin="dense" /> */}
//                         <FormControl fullWidth margin="dense" variant="outlined">
//                             <InputLabel>State</InputLabel>
//                             <Select name="state" value={newMunicipality.state} onChange={handleMunicipalityChange} fullWidth>
//                                 {loading.states ? (
//                                     <MenuItem disabled>
//                                         <CircularProgress size={24} /> Loading...
//                                     </MenuItem>
//                                 ) : (
//                                     stateOptions.map((state) => (
//                                         <MenuItem key={state} value={state}>{state}</MenuItem>
//                                     ))
//                                 )}
//                             </Select>
//                         </FormControl>

//                     </Grid>
//                     <Grid item xs={2}>
//                         {/* <TextField fullWidth label="County" name="county" value={newMunicipality.county} onChange={handleMunicipalityChange} margin="dense" /> */}
//                         <FormControl fullWidth margin="dense" variant="outlined" disabled={!newMunicipality.state}>
//                             <InputLabel>County</InputLabel>
//                             <Select name="county" value={newMunicipality.county} onChange={handleMunicipalityChange} fullWidth>
//                                 {loading.associatedCounties ? (
//                                     <MenuItem disabled>
//                                         <CircularProgress size={24} /> Loading...
//                                     </MenuItem>
//                                 ) : (
//                                     associatedCountyOptions.map((county) => (
//                                         <MenuItem key={county} value={county}>{county}</MenuItem>
//                                     ))
//                                 )}
//                             </Select>
//                         </FormControl>
//                     </Grid>
//                     <Grid item xs={3}>
//                         {/* <TextField fullWidth label="Municipality" name="municipality_name" value={newMunicipality.municipality_name} onChange={handleMunicipalityChange} margin="dense" /> */}
//                         <FormControl fullWidth margin="dense" variant="outlined" disabled={!newMunicipality.state || !newMunicipality.county}>
//                             <InputLabel>Town</InputLabel>
//                             {/* <Select name="municipality_name" value={newMunicipality.municipality_name} onChange={handleMunicipalityChange} fullWidth>
//                                                 {loading.associatedMunicipalities ? (
//                                                     <MenuItem disabled>
//                                                         <CircularProgress size={24} /> Loading...
//                                                     </MenuItem>
//                                                 ) : associatedMunicipalityOptions.length === 0 ? (
//                                                     <MenuItem disabled>No Town available</MenuItem>
//                                                 ) : (
//                                                     associatedMunicipalityOptions.map((municipality) => (
//                                                         <MenuItem key={municipality} value={municipality}>{municipality}</MenuItem>
//                                                     ))
//                                                 )}
//                                             </Select> */}
//                             <Select name="municipality_name" value={newMunicipality.municipality_name} onChange={handleMunicipalityChange} fullWidth>
//                                 {loading.associatedMunicipalities ? (
//                                     <MenuItem disabled>
//                                         <CircularProgress size={24} /> Loading...
//                                     </MenuItem>
//                                 ) : associatedMunicipalityOptions.length === 0 ? (
//                                     <MenuItem disabled>No Town available</MenuItem>
//                                 ) : (
//                                     associatedMunicipalityOptions
//                                         .filter(municipality => municipality !== formData.municipality_name) // Exclude selected municipality
//                                         .map((municipality) => (
//                                             <MenuItem key={municipality} value={municipality}>{municipality}</MenuItem>
//                                         ))
//                                 )}
//                             </Select>
//                         </FormControl>
//                     </Grid>

//                     <Grid item xs={4}>
//                         <FormControl fullWidth margin="dense">
//                             <InputLabel>Channel URLs</InputLabel>
//                             <Select multiple value={newMunicipality.channel_urls} onChange={handleChannelSelect} fullWidth>
//                                 {/* {channelOptions.map((url) => <MenuItem key={url} value={url}>{url}</MenuItem>)} */}
//                                 {channelOptions.length > 0 ? (
//                                     channelOptions.map((url) => (
//                                         <MenuItem key={url} value={url}>{url}</MenuItem>
//                                     ))
//                                 ) : (
//                                     <MenuItem disabled>No BOE Channel associated</MenuItem>
//                                 )}
//                             </Select>
//                         </FormControl>
//                     </Grid>


//                 </Grid>

                



//             </DialogContent>

//             <DialogActions>
//                 <Button onClick={onClose} color="secondary">Cancel</Button>
//                 <Button variant="contained" color="primary" onClick={handleSave}>
//                     Save
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// };

// export default EditMappingForm;
import { useState, useEffect } from "react";
import { Button, Grid, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, FormControl, InputLabel, Select, CircularProgress, Typography } from "@material-ui/core";

import axios from "axios";
import { BACKEND_BASE_URL } from "../config";

const EditMappingForm = ({ open, onClose, onMappingUpdated, mappingData }) => {
    console.log("Mapping Data in Edit Form:", mappingData);
    console.log("onMappingUpdated:", onMappingUpdated);
    
    const [countryOptions, setCountryOptions] = useState([]);
    
    // Main form options (for big town)
    const [stateOptions, setStateOptions] = useState([]);
    const [countyOptions, setCountyOptions] = useState([]);
    const [municipalityOptions, setMunicipalityOptions] = useState([]);
    
    // Associated municipalities options (for small towns) - separate state
    const [associatedStateOptions, setAssociatedStateOptions] = useState([]);
    const [associatedCountyOptions, setAssociatedCountyOptions] = useState([]);
    const [associatedMunicipalityOptions, setAssociatedMunicipalityOptions] = useState([]);
    
    const [channelOptions, setChannelOptions] = useState([]);
    
    const [loadingStates, setLoadingStates] = useState(false);
    const [loadingCounties, setLoadingCounties] = useState(false);
    const [loadingMunicipalities, setLoadingMunicipalities] = useState(false);
    
    const [loading, setLoading] = useState({ 
        countries: false,
        states: false, 
        counties: false, 
        municipalities: false, 
        associatedStates: false,
        associatedCounties: false,
        associatedMunicipalities: false,
        channels: false,
        saving: false
    });

    const [formData, setFormData] = useState({
        country: "",
        state: "",
        county: "",
        municipality_name: "",
        municipalities: [],
    });

    const [newMunicipality, setNewMunicipality] = useState({
        country: "",
        state: "",
        county: "",
        municipality_name: "",
        channel_type: "Board of Education",
        channel_urls: [],
    });

    useEffect(() => {
        if (open && mappingData) {
            const smallTownCountryId = countryOptions.find(
                country => country.name === mappingData.small_town[0]?.country
            )?.id || "";
            
            setFormData({
                country: mappingData.big_town.country__id || "",
                state: mappingData.big_town.state,
                county: mappingData.big_town.county,
                municipality_name: mappingData.big_town.municipality_name,
                municipalities: mappingData.small_town[0] ? [mappingData.small_town[0]] : [],
            });
            
            setNewMunicipality({
                country: smallTownCountryId || "",
                state: mappingData.small_town[0].state,
                county: mappingData.small_town[0].county,
                municipality_name: mappingData.small_town[0].municipality_name,
                channel_type: "Board of Education",
                channel_urls: mappingData.small_town[0].channel_urls,
            });
        }
    }, [open, mappingData, countryOptions]);

    useEffect(() => {
        if (open) {
            fetchCountries();
        }
    }, [open]);

    // MAIN FORM useEffect hooks - only affect main form state
    useEffect(() => {
        if (formData.country) {
            fetchStates();
        } else {
            setStateOptions([]);
            setFormData(prev => ({ ...prev, state: "", county: "", municipality_name: "" }));
        }
    }, [formData.country]);

    useEffect(() => {
        if (formData.state) {
            fetchCounties();
        } else {
            setCountyOptions([]);
            setFormData(prev => ({ ...prev, county: "", municipality_name: "" }));
        }
    }, [formData.state]);

    useEffect(() => {
        if (formData.state && formData.county) {
            fetchMunicipalities();
        } else {
            setMunicipalityOptions([]);
            setFormData(prev => ({ ...prev, municipality_name: "" }));
        }
    }, [formData.state, formData.county]);

    useEffect(() => {
        if (formData.state && formData.county && formData.municipality_name) {
            fetchChannels();
        } else {
            setChannelOptions([]);
        }
    }, [formData.state, formData.county, formData.municipality_name]);

    // ASSOCIATED MUNICIPALITIES useEffect hooks - only affect associated municipalities state
    useEffect(() => {
        if (newMunicipality.country) {
            fetchAssociatedStates();
        } else {
            setAssociatedStateOptions([]);
            setAssociatedCountyOptions([]);
            setAssociatedMunicipalityOptions([]);
            setNewMunicipality(prev => ({ ...prev, state: "", county: "", municipality_name: "" }));
        }
    }, [newMunicipality.country]);

    useEffect(() => {
        if (newMunicipality.state) {
            fetchAssociatedCounties();
        } else {
            setAssociatedCountyOptions([]);
            setAssociatedMunicipalityOptions([]);
            setNewMunicipality(prev => ({ ...prev, county: "", municipality_name: "" }));
        }
    }, [newMunicipality.state]);

    useEffect(() => {
        if (newMunicipality.state && newMunicipality.county) {
            fetchAssociatedMunicipalities();
        } else {
            setAssociatedMunicipalityOptions([]);
            setNewMunicipality(prev => ({ ...prev, municipality_name: "" }));
        }
    }, [newMunicipality.state, newMunicipality.county]);

    const fetchCountries = async () => {
        setLoading((prev) => ({ ...prev, countries: true }));
        try {
            const { data } = await axios.get(`${BACKEND_BASE_URL}/api/countries/`);
            setCountryOptions(data || []);
        } catch (error) {
            console.error("Error fetching countries:", error);
        }
        setLoading((prev) => ({ ...prev, countries: false }));
    };

    // MAIN FORM fetch functions
    const fetchStates = async () => {
        if (!formData.country) return;
        setLoadingStates(true);
        setLoading((prev) => ({ ...prev, states: true }));
        try {
            const response = await axios.get(`${BACKEND_BASE_URL}/api/states/`, {
                params: { country_id: formData.country }
            });
            if (response.data && response.data.states) {
                setStateOptions(response.data.states);
            }
        } catch (error) {
            console.error("Error fetching states:", error);
            setStateOptions([]);
        }
        setLoadingStates(false);
        setLoading((prev) => ({ ...prev, states: false }));
    };

    const fetchCounties = async () => {
        if (!formData.state) return;
        setLoadingCounties(true);
        try {
            const { data } = await axios.get(`${BACKEND_BASE_URL}/api/counties/`, { 
                params: { state: formData.state } 
            });
            setCountyOptions(data?.counties || []);
        } catch (error) {
            console.error("Error fetching counties:", error);
            setCountyOptions([]);
        }
        setLoadingCounties(false);
    };

    const fetchMunicipalities = async () => {
        if (!formData.state || !formData.county) return;
        setLoadingMunicipalities(true);
        try {
            const { data } = await axios.get(`${BACKEND_BASE_URL}/api/municipalities/filter/`, {
                params: { state: formData.state, county: formData.county },
            });
            setMunicipalityOptions(data?.municipalities || []);
        } catch (error) {
            console.error("Error fetching municipalities:", error);
            setMunicipalityOptions([]);
        }
        setLoadingMunicipalities(false);
    };

    const fetchChannels = async () => {
        if (!formData.state || !formData.county || !formData.municipality_name) return;
        setLoading((prev) => ({ ...prev, channels: true }));
        try {
            const { data } = await axios.get(`${BACKEND_BASE_URL}/api/municipality/channel-urls/`, {
                params: { 
                    state: formData.state, 
                    county: formData.county, 
                    municipality: formData.municipality_name 
                },
            });
            setChannelOptions(data?.channel_urls || []);
        } catch (error) {
            console.error("Error fetching channels:", error);
            setChannelOptions([]);
        }
        setLoading((prev) => ({ ...prev, channels: false }));
    };

    // ASSOCIATED MUNICIPALITIES fetch functions - separate from main form
    const fetchAssociatedStates = async () => {
        if (!newMunicipality.country) return;
        setLoading((prev) => ({ ...prev, associatedStates: true }));
        try {
            const response = await axios.get(`${BACKEND_BASE_URL}/api/states/`, {
                params: { country_id: newMunicipality.country }
            });
            if (response.data && response.data.states) {
                setAssociatedStateOptions(response.data.states);
            }
        } catch (error) {
            console.error("Error fetching associated states:", error);
            setAssociatedStateOptions([]);
        }
        setLoading((prev) => ({ ...prev, associatedStates: false }));
    };

    const fetchAssociatedCounties = async () => {
        if (!newMunicipality.state) return;
        setLoading((prev) => ({ ...prev, associatedCounties: true }));
        try {
            const { data } = await axios.get(`${BACKEND_BASE_URL}/api/counties/`, { 
                params: { state: newMunicipality.state } 
            });
            setAssociatedCountyOptions(data?.counties || []);
        } catch (error) {
            console.error("Error fetching counties:", error);
            setAssociatedCountyOptions([]);
        }
        setLoading((prev) => ({ ...prev, associatedCounties: false }));
    };

    const fetchAssociatedMunicipalities = async () => {
        if (!newMunicipality.state || !newMunicipality.county) return;
        setLoading((prev) => ({ ...prev, associatedMunicipalities: true }));
        try {
            const { data } = await axios.get(`${BACKEND_BASE_URL}/api/municipalities/filter/`, { 
                params: { state: newMunicipality.state, county: newMunicipality.county } 
            });
            setAssociatedMunicipalityOptions(data?.municipalities || []);
        } catch (error) {
            console.error("Error fetching municipalities:", error);
            setAssociatedMunicipalityOptions([]);
        }
        setLoading((prev) => ({ ...prev, associatedMunicipalities: false }));
    };

    const handleChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value });
        setNewMunicipality((prev) => ({
            ...prev,
            channel_urls: [], // Reset channel URLs
        }));
    };

    const handleMunicipalityChange = (event) => {
        setNewMunicipality(prev => ({
            ...prev,
            [event.target.name]: event.target.value
        }));
    };

    const handleChannelSelect = (event) => {
        setNewMunicipality({ ...newMunicipality, channel_urls: event.target.value });
    };

    const handleSave = async () => {
        setLoading(prev => ({ ...prev, saving: true }));
        try {
            // const updatedMunicipalities = [...formData.municipalities, newMunicipality];

            await axios.patch(`${BACKEND_BASE_URL}/api/mapping-towns/${mappingData.id}/`, {
                country: formData.country,
                state: formData.state,
                county: formData.county,
                big_town: formData.municipality_name,
                small_town: [newMunicipality],
            });
            onClose();
            onMappingUpdated();
        } catch (error) {
            console.error("Error updating mapping:", error);
        }
        setLoading(prev => ({ ...prev, saving: false }));
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Edit Mapping</DialogTitle>
            <DialogContent>
                {/* Country Dropdown */}
                <FormControl fullWidth margin="dense" variant="outlined">
                    <InputLabel>Country</InputLabel>
                    <Select name="country" value={formData.country} onChange={handleChange} fullWidth>
                        {loading.countries ? (
                            <MenuItem disabled>
                                <CircularProgress size={24} /> Loading...
                            </MenuItem>
                        ) : (
                            countryOptions.map((country) => (
                                <MenuItem key={country.id} value={country.id}>{country.name}</MenuItem>
                            ))
                        )}
                    </Select>
                </FormControl>

                {/* State Dropdown */}
                <FormControl fullWidth margin="dense" variant="outlined" disabled={!formData.country}>
                    <InputLabel>State</InputLabel>
                    <Select name="state" value={formData.state} onChange={handleChange} fullWidth>
                        {loading.states ? (
                            <MenuItem disabled>
                                <CircularProgress size={24} /> Loading...
                            </MenuItem>
                        ) : stateOptions.length === 0 ? (
                            <MenuItem disabled>No States available</MenuItem>
                        ) : (
                            stateOptions.map((state) => (
                                <MenuItem key={state} value={state}>{state}</MenuItem>
                            ))
                        )}
                    </Select>
                </FormControl>

                {/* County Dropdown */}
                <FormControl fullWidth margin="dense" variant="outlined" disabled={!formData.state}>
                    <InputLabel>County</InputLabel>
                    <Select name="county" value={formData.county} onChange={handleChange} fullWidth>
                        {loadingCounties ? (
                            <MenuItem disabled>
                                <CircularProgress size={24} /> Loading...
                            </MenuItem>
                        ) : (
                            countyOptions.map((county) => (
                                <MenuItem key={county} value={county}>{county}</MenuItem>
                            ))
                        )}
                    </Select>
                </FormControl>

                {/* Town Dropdown */}
                <FormControl fullWidth margin="dense" variant="outlined" disabled={!formData.state || !formData.county}>
                    <InputLabel>Town</InputLabel>
                    <Select name="municipality_name" value={formData.municipality_name} onChange={handleChange} fullWidth>
                        {loadingMunicipalities ? (
                            <MenuItem disabled>
                                <CircularProgress size={24} /> Loading...
                            </MenuItem>
                        ) : municipalityOptions.length === 0 ? (
                            <MenuItem disabled>No Town available</MenuItem>
                        ) : (
                            municipalityOptions.map((municipality) => (
                                <MenuItem key={municipality} value={municipality}>{municipality}</MenuItem>
                            ))
                        )}
                    </Select>
                </FormControl>

                {/* Associated Towns Section */}
                <Typography variant="h6" style={{ marginTop: 10 }}>Associated Towns</Typography>
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <FormControl fullWidth margin="dense" variant="outlined">
                            <InputLabel>Country</InputLabel>
                            <Select name="country" value={newMunicipality.country} onChange={handleMunicipalityChange} fullWidth>
                                {loading.countries ? (
                                    <MenuItem disabled>
                                        <CircularProgress size={24} /> Loading...
                                    </MenuItem>
                                ) : (
                                    countryOptions.map((country) => (
                                        <MenuItem key={country.id} value={country.id}>{country.name}</MenuItem>
                                    ))
                                )}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={2}>
                        <FormControl fullWidth margin="dense" variant="outlined" disabled={!newMunicipality.country}>
                            <InputLabel>State</InputLabel>
                            <Select name="state" value={newMunicipality.state} onChange={handleMunicipalityChange} fullWidth>
                                {loading.associatedStates ? (
                                    <MenuItem disabled>
                                        <CircularProgress size={24} /> Loading...
                                    </MenuItem>
                                ) : associatedStateOptions.length === 0 ? (
                                    <MenuItem disabled>No States available</MenuItem>
                                ) : (
                                    associatedStateOptions.map((state) => (
                                        <MenuItem key={state} value={state}>{state}</MenuItem>
                                    ))
                                )}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={2}>
                        <FormControl fullWidth margin="dense" variant="outlined" disabled={!newMunicipality.state}>
                            <InputLabel>County</InputLabel>
                            <Select name="county" value={newMunicipality.county} onChange={handleMunicipalityChange} fullWidth>
                                {loading.associatedCounties ? (
                                    <MenuItem disabled>
                                        <CircularProgress size={24} /> Loading...
                                    </MenuItem>
                                ) : (
                                    associatedCountyOptions.map((county) => (
                                        <MenuItem key={county} value={county}>{county}</MenuItem>
                                    ))
                                )}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl fullWidth margin="dense" variant="outlined" disabled={!newMunicipality.state || !newMunicipality.county}>
                            <InputLabel>Town</InputLabel>
                            <Select name="municipality_name" value={newMunicipality.municipality_name} onChange={handleMunicipalityChange} fullWidth>
                                {loading.associatedMunicipalities ? (
                                    <MenuItem disabled>
                                        <CircularProgress size={24} /> Loading...
                                    </MenuItem>
                                ) : associatedMunicipalityOptions.length === 0 ? (
                                    <MenuItem disabled>No Town available</MenuItem>
                                ) : (
                                    associatedMunicipalityOptions
                                        .filter(municipality => municipality !== formData.municipality_name) // Exclude selected municipality
                                        .map((municipality) => (
                                            <MenuItem key={municipality} value={municipality}>{municipality}</MenuItem>
                                        ))
                                )}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl fullWidth margin="dense" variant="outlined">
                            <InputLabel>Channel URLs</InputLabel>
                            <Select multiple value={newMunicipality.channel_urls} onChange={handleChannelSelect} fullWidth>
                                {channelOptions.length > 0 ? (
                                    channelOptions.map((url) => (
                                        <MenuItem key={url} value={url}>{url}</MenuItem>
                                    ))
                                ) : (
                                    <MenuItem disabled>No BOE Channel associated</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="secondary">Cancel</Button>
                <Button variant="contained" color="primary" onClick={handleSave} disabled={loading.saving}>
                    {loading.saving ? <CircularProgress size={24} /> : "Save"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditMappingForm;